import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Label, Pagination } from 'ypf-pas-general-ui-components';

import DailyTotal from '../ApprovalPending/ViewApprovalPendingContainer/DailyTotal/DailyTotal';
import HeaderLocation from '../ApprovalPending/ViewApprovalPendingContainer/HeaderLocation/HeaderLocation';
import HeaderTableApprovalPending from '../ApprovalPending/ViewApprovalPendingContainer/TableApproval/HeaderTableApprovalPending';
import { formatFullDate, formatsEnum } from '../../utils/formatUtils';
import NoWorkReports from '../WorkReports/NoWorkReports';
import InputCalendar from '../Calendar/InputCalendar/InputCalendar';
import './ApprovalSend.scss';
import { workReportsProp } from '../../utils/globalPropTypes';
import ApprovalHeaderButtons from '../ApprovalPending/ApprovalHeaderButtons/ApprovalHeaderButtons';

const ApprovalSend = ({
  calendarioRevision,
  fetchData,
  pageIndex,
  partesDiarios,
  selectedDate,
  setDateWorkReport,
  setIsPending,
  setPageIndex,
  totalPages,
  totalRecords,
  workReports,
  handleGoFirstLastDay,
  handleOrderByUbication,
  isOrderByUbication,
  handlePageSize,
  size
}) => {
  useEffect(() => {
    setIsPending(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [pendingDates, setPendingDates] = useState([]);

  const goToPage = (number) => {
    setPageIndex(number);
  };

  const nextPage = () => {
    if (pageIndex + 1 !== totalPages && totalPages !== 0) {
      setPageIndex(pageIndex + 1);
    }
  };

  const previousPage = () => {
    if (pageIndex !== 0) {
      setPageIndex(pageIndex - 1);
    }
  };

  // End of Pagination logic
  useEffect(() => {
    if (calendarioRevision) {
      const dates = calendarioRevision.length
        ? calendarioRevision.map((dateCalendar) => {
            const dateCalendarReverse = dateCalendar.split('/').reverse().join('-');

            return formatFullDate(dateCalendarReverse, formatsEnum.FORMAT_DATE_2);
          })
        : [];

      setPendingDates(dates);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calendarioRevision]);

  const onChangeDate = (value) => {
    const newDate = formatFullDate(value, formatsEnum.FORMAT_DATE_2);
    const formatedSelectedDate = formatFullDate(selectedDate, formatsEnum.FORMAT_DATE_2);

    if (formatedSelectedDate !== newDate) setDateWorkReport(newDate);
  };

  return (
    <div className="container-approval-send">
      <div className="d-flex justify-content-between">
        <div>
          <Label icon="" label="Parte del día" size="md" sizeValue="md" value="" />
          <InputCalendar
            arrayDate={pendingDates}
            handleChangeDate={onChangeDate}
            onClickFirstDay={() => handleGoFirstLastDay(true)}
            onClickLastDay={() => handleGoFirstLastDay()}
            pendingLineTooltipText
            selectDay={selectedDate}
          />
        </div>
        <DailyTotal daily={partesDiarios} title="Validaciones Realizadas" />
      </div>
      <hr />
      <ApprovalHeaderButtons
        handleOrderByUbication={handleOrderByUbication}
        isEmpty={!workReports.length}
        isOrderByUbication={isOrderByUbication}
        isPending={false}
        pageNumber={pageIndex}
        pageSize={size}
        selectedDate={selectedDate}
      />
      {workReports && workReports.length > 0 ? (
        <>
          {workReports?.map((workReport) => (
            <>
              <HeaderLocation
                isOrderByUbication={isOrderByUbication}
                location={workReport.agrupadoPor}
              />
              <HeaderTableApprovalPending
                fetchData={fetchData}
                selectedDate={selectedDate}
                selectedInput="ENVIADOS"
                showApproveButton={false}
                showEditButton
                showPPButton={false}
                showRejectButton={false}
                workReportsSecondLevel={workReport?.items}
              />
            </>
          ))}
          <div className="d-flex justify-content-start">
            <div className="d-flex gap-2">
              <Pagination
                cantFiles={[10, 20, 30, 50]}
                explicitSize
                gotoPage={goToPage}
                nextPage={nextPage}
                pageIndex={pageIndex}
                previousPage={previousPage}
                rowsType={isOrderByUbication ? 'ubicaciones' : 'proveedores'}
                setPageSize={handlePageSize}
                size={size}
                totalPages={totalPages}
              />
              <div className="d-flex justify-content-center align-items-center">
                <h6 className="mb-0" style={{ color: '#797979' }}>
                  Registros totales: {totalRecords}
                </h6>
              </div>
            </div>
          </div>
        </>
      ) : (
        <NoWorkReports
          subtitle="-"
          title="No se encontraron partes diarios para la fecha seleccionada"
        />
      )}
    </div>
  );
};

export default ApprovalSend;

ApprovalSend.propTypes = {
  calendarioRevision: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleGoFirstLastDay: PropTypes.func.isRequired,
  pageIndex: PropTypes.number.isRequired,
  partesDiarios: PropTypes.number.isRequired,
  selectedDate: PropTypes.string.isRequired,
  setDateWorkReport: PropTypes.func.isRequired,
  setIsPending: PropTypes.func.isRequired,
  setPageIndex: PropTypes.func.isRequired,
  size: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  totalRecords: PropTypes.number.isRequired,
  fetchData: PropTypes.func.isRequired,
  workReports: workReportsProp.isRequired,
  handleOrderByUbication: PropTypes.func.isRequired,
  isOrderByUbication: PropTypes.bool.isRequired,
  handlePageSize: PropTypes.func.isRequired
};
